module.exports = __webpack_public_path__ + "img/numberBlocking.8fe94107.png";